export const CNY_BANK_CHANNEL_NOTE_1 = `The recipient will receive an email with a link to register with our partner-
Geoswift. Once you initiate a transfer, your recipient will also receive a message
from our partner - Geoswift to accept the payment to receive funds instantly to
their bank account. Recipient will be able to accept the payment only after the
aforementioned registration completion.`;
export const CNY_BANK_CHANNEL_NOTE_2 = `Registration and acceptance of transfer request must be completed with 48 hours to
avoid cancellation.`;

export const CASH_PAYOUT_TEXT_1_PART_1 = `You will get to choose recipient’s cash pickup partner from the `;
export const CASH_PAYOUT_TEXT_1_PART_2 = ` available cash pickup partners, `;
export const CASH_PAYOUT_TEXT_1_PART_3 = `at the time of setting up the transfer. `;

export const CASH_PAYOUT_TEXT_2_PART_1 = `After successful transaction, Recipient can pickup cash from the selected cash pickup partner. `;
export const CASH_PAYOUT_TEXT_2_PART_2 = `While collecting cash, recipient will have to show a valid id. `;
export const CASH_PAYOUT_TEXT_2_PART_3 = ` View IDs`;

export const MONEYGRAM_CASH_PAYOUT_TEXT_1_PART_1 = `The recipient can collect the cash from any of the `;
export const MONEYGRAM_CASH_PAYOUT_TEXT_1_PART_2 = ` listed MoneyGram locations. `;

export const MONEY_GRAM_PAYOUT_TEXT_2 = `Once the transaction is processed, 
a reference number will be shared with you and your recipient`;

export const MONEY_GRAM_PAYOUT_TEXT_3_PART_1 = `Make sure your recipient has this reference number along with a `;
export const MONEY_GRAM_PAYOUT__TEXT_3_PART_2 = `valid identity proof`;
export const MONEY_GRAM_PAYOUT_TEXT_3_PART_3 = ` while collecting cash from our pick-up partner.`;
